import script from "./PortalAppHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortalAppHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PortalAppHeader.vue?vue&type=style&index=0&id=3d66fff1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d66fff1"]])

export default __exports__